import { Button } from '@dasa-health/components-react'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { Footer } from './styles'

type SignUpFooterProps = {
    showBackButton?: boolean
    hideSubmitButton?: boolean
    passwordResetFlow?: boolean
    isSubmitButtonDisabled?: boolean
    isSubmitButtonLoading?: boolean
    submitButtonText?: string
    disableSubmitButtonVisuallyOnly?: boolean
    backButtonText?: string
}

export const SignUpFooter = ({
    showBackButton = true,
    hideSubmitButton = false,
    passwordResetFlow = true,
    isSubmitButtonDisabled = false,
    disableSubmitButtonVisuallyOnly = false,
    isSubmitButtonLoading = false,
    submitButtonText = 'Continuar',
    backButtonText = 'Voltar',
}: SignUpFooterProps) => {
    const history = useHistory()

    const onBackButton = () => {
        history.goBack()
    }

    const dataCurrentService = ['Reset Senha', 'Cadastro']

    return (
        <Footer>
            {showBackButton && (
                <Button
                    className="footer__button"
                    data-testid="footer-back-button"
                    disabled={isSubmitButtonLoading}
                    onClick={onBackButton}
                    size="default"
                    type="button"
                    variant="tertiary"
                >
                    {backButtonText}
                </Button>
            )}
            {!hideSubmitButton && (
                <Button
                    className={[
                        'footer__button',
                        'footer__button--submit',
                        isSubmitButtonDisabled && disableSubmitButtonVisuallyOnly ? 'footer__button--disabled' : '',
                    ].join(' ')}
                    data-current-service={passwordResetFlow ? dataCurrentService[0] : dataCurrentService[1]}
                    data-item-position="Token"
                    data-item-text="Continuar"
                    data-testid="submit-button"
                    disabled={(!disableSubmitButtonVisuallyOnly && isSubmitButtonDisabled) || isSubmitButtonLoading}
                    isLoading={isSubmitButtonLoading}
                    size="default"
                    type="submit"
                    variant="primary"
                >
                    {submitButtonText}
                </Button>
            )}
        </Footer>
    )
}
